import axios from "@/axios";

export default {
	namespaced: true,
	state: {

		// Calendar Labels
		eventLabels: [],

		// Simple Calendar State
		events: []
	},
	mutations: {
		ADD_EVENT(state, event) {
			state.events = [...state.events, event]
		},
		SET_EVENTS(state, events) {
			state.events = events
		},
		SET_TASK_COMPLETED(state, task_id) {
			const task = state.events.find((e) => e.id === task_id);
			task.is_completed = true;
		},
		SET_TASK_BY_ADMIN(state, task_id) {
			const task = state.events.find((e) => e.id === task_id);
			task.is_by_admin = true;
		},
		REOPEN_TASK(state, task_id) {
			const task = state.events.find((e) => e.id === task_id)
			task.is_completed = false;
		},
		SET_LABELS(state, labels) {
			state.eventLabels = labels
		},
		UPDATE_EVENT(state, event) {
			const eventIndex = state.events.findIndex((e) => e.id === event.id)
			Object.assign(state.events[eventIndex], event)
		},
		DELETE_TASK(state, eventId) {
			const taskIndex = state.events.findIndex((e) => e.id === eventId)
			state.events.splice(taskIndex, 1)
		},
		NOT_RELEVANT_TASK(state, eventId) {
			const taskIndex = state.events.findIndex((e) => e.id === eventId)
			state.events.splice(taskIndex, 1)
		}
	},
	actions: {
		async addEvent({commit, dispatch, rootGetters}, event, ) {
			try {
				let res = await axios.post(`${rootGetters['getRole']}/task/create`, event);
				if (res.data) {
					commit('ADD_EVENT', res.data.data);
				}
			} catch (e) {
				console.error(e)
			}

			// await dispatch('updateNotifications');
		},

		async setTaskCompleted({commit, dispatch, rootGetters}, task) {
			try {
				let res = await axios.post(`${rootGetters['getRole']}/task/complete/${task.id}`,{is_completed: true})
				if (res.status === 200) commit('SET_TASK_COMPLETED', task.id)
			} catch (e) {
				console.error(e)
			}

			// await dispatch('updateNotifications');
		},

		async reopenTask({commit, dispatch, rootGetters}, task) {
			try {
				let res = await axios.post(`${rootGetters['getRole']}/task/complete/${task.id}`,{is_completed: false})
				if (res.status === 200) commit('REOPEN_TASK', task.id)
			}
			catch (e){
				console.error(e)
			}

			// await dispatch('updateNotifications');
		},

		async notRelevantTaskTask({commit, dispatch, rootGetters}, task) {
			commit('NOT_RELEVANT_TASK', task.id);
			// await dispatch('updateNotifications');
		},

		async deleteTask({commit, dispatch, rootGetters}, task) {
			try {
				let res = await axios.post(`${rootGetters['getRole']}/task/delete/${task.id}`)
				if (res.status === 200) commit('DELETE_TASK', task.id)
			}
			catch (e){
				console.error(e)
			}

			// await dispatch('updateNotifications');
		},

		async fetchEvents({commit, rootGetters}) {
			try {
				let res = await axios.get(`${rootGetters['getRole']}/task`);

				if (res.data.data) {
					commit('SET_EVENTS', res.data.data)
				}
			} catch (e) {
				console.error(e)
			}
		},

		async assignTaskToManager({commit}, {task, manager}){
			try{
				let res = await axios.post(`admin/task/assign-to-manager/${task.id}`, {manager_id:manager.id})
				if(res.status === 200) commit("SET_TASK_BY_ADMIN", task.id)
			}
			catch (e){
				console.error(e)
			}
		},

		eventDragged({commit}, payload) {
			// return new Promise((resolve, reject) => {
			// 	axios.post(`/api/apps/calendar/event/dragged/${payload.event.id}`, {payload})
			// 		.then((response) => {
			//
			// 			// Convert Date String to Date Object
			// 			const event = response.data
			// 			event.startDate = new Date(event.startDate)
			// 			event.endDate = new Date(event.endDate)
			//
			// 			commit('UPDATE_EVENT', event)
			// 			resolve(response)
			// 		})
			// 		.catch((error) => {
			// 			reject(error)
			// 		})
			// })
		}
	},
	getters: {
		getEvent: state => (eventId) => state.events.find((event) => event.id === eventId),
		getEvents: state => state.events.map(event => {
			return {...event, title: event.description, startDate: event.date_time}
		})
	}
}
